import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

interface PublicSurveyErrorProps {
  message: string;
  isPreview?: boolean;
}

export const PublicSurveyError: React.FC<PublicSurveyErrorProps> = ({
  message,
  isPreview = false,
}) => {
  return (
    <div
      className={`public-survey-hero-bg ${isPreview ? 'public-survey-hero-bg--preview' : ''} d-flex align-items-center justify-content-center p-4`}
    >
      <div className="public-survey-error-wrapper">
        <div className="public-survey-error-card public-survey-glass public-survey-shadow-lg">
          <div className="public-survey-error-icon">
            <FaExclamationTriangle size={48} />
          </div>
          <h3>{message}</h3>
        </div>
      </div>
    </div>
  );
};
